var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6732 11.7972C25.6732 6.64254 21.4946 2.46387 16.3399 2.46387C12.5545 2.46387 9.29543 4.71737 7.83057 7.95573C4.5927 9.42039 2.33984 12.6791 2.33984 16.4639C2.33984 21.6185 6.51852 25.7972 11.6732 25.7972C15.458 25.7972 18.7167 23.5444 20.181 20.3059C23.4197 18.8416 25.6732 15.5826 25.6732 11.7972ZM11.1082 7.14626C12.3904 5.70505 14.2591 4.7972 16.3399 4.7972C20.2059 4.7972 23.3399 7.93121 23.3399 11.7972C23.3399 13.8783 22.4317 15.7472 20.9897 17.0291C21.0008 16.8421 21.0065 16.6537 21.0065 16.4639C21.0065 11.3092 16.8279 7.13053 11.6732 7.13053C11.4838 7.13053 11.2957 7.13617 11.1082 7.14626ZM14.7679 16.2603L11.4681 12.9604L8.16827 16.2603L11.4681 19.5601L14.7679 16.2603Z",
    fill: "url(#paint0_linear_47537_77302)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47537_77302",
    x1: 14.0065,
    y1: 2.46387,
    x2: 14.0065,
    y2: 39.2735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/Assets.6d86475ce0ae024ce699ebcbd08e0b71.svg";
export { ForwardRef as ReactComponent };